import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, ArrowLeft, MessageSquare } from 'lucide-angular';

/**
 * Chat Header Component - Shared header for both chat implementations
 * Reduces 70%+ HTML duplication
 */
@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  template: `
    <div class="chat-header p-4 sm:p-6 flex items-center gap-2 sm:gap-4 w-full">
      <div class="flex items-center gap-2 sm:gap-4">
        <button (click)="onBack.emit()" class="icon-button flex-shrink-0">
          <lucide-angular [img]="ArrowLeft" class="w-4 h-4 sm:w-5 sm:h-5"></lucide-angular>
        </button>
        <div class="flex items-center gap-2 sm:gap-3 min-w-0">
          <div
            class="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-xl sm:rounded-2xl flex-shrink-0 flex items-center justify-center shadow-soft relative overflow-hidden"
            [ngStyle]="botGradientStyle"
          >
            <div class="absolute inset-0 bg-black/10 mix-blend-overlay"></div>
            <lucide-angular
              [img]="botIcon || MessageSquare"
              class="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white relative z-10"
            ></lucide-angular>
          </div>
          <div class="min-w-0">
            <h2 class="!mb-0 truncate">
              {{ botName }}
            </h2>
            <div class="flex items-center gap-1.5 sm:gap-2">
              <div [class]="'w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full ' + statusColorClass"></div>
              <span class="text-xs text-light-text-secondary dark:text-dark-text-secondary capitalize truncate">
                {{ statusText }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class ChatHeaderComponent {
  @Input() botName?: string;
  @Input() botGradientStyle: any = {};
  @Input() botIcon?: any;
  @Input() statusColorClass: string = 'bg-gray-400';
  @Input() statusText: string = 'Desconectado';
  @Output() onBack = new EventEmitter<void>();

  readonly ArrowLeft = ArrowLeft;
  readonly MessageSquare = MessageSquare;
}
